export function getById(id) {
  return document.getElementById(id);
}

export function getByClass(id) {
  return document.getElementsByClassName(id)[0];
}
